import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
type PreviewNotAvailableProps = {
  mimeType: string;
};
const PreviewNotAvailable = t0 => {
  const $ = _c(6);
  const {
    mimeType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "viewers.preview"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("artifact", t1);
  let t2;
  if ($[1] !== mimeType || $[2] !== t) {
    t2 = t(_temp, {
      type: mimeType || t(_temp2)
    });
    $[1] = mimeType;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="flex h-full items-center justify-center p-6 text-body-2 text-secondary">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default PreviewNotAvailable;
function _temp($) {
  return $.notAvailable;
}
function _temp2($_0) {
  return $_0.unknownType;
}